function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1,1)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  transform: "translate(3.17,5)",
  d: "M15.8,0L0,13.3L0,35L11.1,35L11.1,21.7L20.6,21.7L20.6,35L31.7,35L31.7,13.3L15.8,0L15.8,0zM30.1,33.3L22.2,33.3L22.2,20L9.5,20L9.5,33.3L1.6,33.3L1.6,14.1L15.8,2.1L30.1,14.1L30.1,33.3L30.1,33.3z",
  id: "shape1"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  transform: "translate(0,-0)",
  d: "M19,0L9.5,8L9.5,3.3L3.2,3.3L3.2,13.3L0,16L1.1,17.2L19,2.1L36.9,17.2L38,16L19,0L19,0zM7.9,9.3L4.8,12L4.8,5L7.9,5L7.9,9.3L7.9,9.3z",
  id: "shape2"
}));

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 42",
    width: 40,
    height: 42,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.51ff9d8e.svg";
export { ForwardRef as ReactComponent };